import { mixpanel, bianka } from '@fiverr-private/obs';
import { Click, ClickType, ElementType } from '@fiverr-private/bianka_js';

const EVENT = {
    CLICK: 'Clicked Nav Bar',
    HOVER: 'Hovered Nav Bar'
};

const formatEventData = ({ vertical, id, context, menuItemId, path, bucket, entry }) => ({
    vertical,
    context,
    bucket,
    entry,
    'subcat-id': id,
    'category-id': menuItemId,
    'link': path
});

const sendMixpanel = (type, event) => {
    if (typeof MixpanelWrapper === 'object' && typeof MixpanelWrapper.trackEvent === 'function') {
        MixpanelWrapper.trackEvent(type, event);
    } else {
        mixpanel.track(type, event);
    }
};

export const trackClick = (data) => sendMixpanel(EVENT.CLICK, formatEventData(data));

export const trackHover = (data) => sendMixpanel(EVENT.HOVER, formatEventData(data));

export const trackBriefCtaClick = ({ pathname, pageCtxId, organizationId, ctaSource }) => {
    bianka.reportActivity({
        type: Click,
        event: {
            type: 'clicked_on_post_a_brief_cta',
            page: { name: pathname, ctxId: pageCtxId },
            ...(organizationId && { organization: { id: organizationId } }),
            clickType: ClickType.UNSPECIFIED,
            element: {
                type: ElementType.BUTTON,
                name: ctaSource,
                text: {
                    value: 'sourcing'
                }
            }
        }
    });
};
